import { render, staticRenderFns } from "./CoreComponent.vue?vue&type=template&id=5318e12a&scoped=true&"
import script from "./CoreComponent.vue?vue&type=script&lang=js&"
export * from "./CoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./CoreComponent.vue?vue&type=style&index=0&id=5318e12a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318e12a",
  null
  
)

export default component.exports